"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { FUSportsMatchEvent } from "fansunited-data-layer";
import { GoalIcon } from "@/components/ui/icons/PlayerEventIcons";
import { PlayerImage } from "./PlayerImage";
import { PlayerLink } from "./PlayerLink";
import { getEventTypeLabel, getPlayerPhoto, type EventLabels } from "./matchEventHelpers";
interface GoalCardProps {
  event: FUSportsMatchEvent;
  showPhotos: boolean;
  eventLabels: EventLabels;
}

/**
 * GoalCard - Displays a goal event with bold, inverted colors
 */
export const GoalCard: React.FC<GoalCardProps> = t0 => {
  const $ = _c(30);
  const {
    event,
    showPhotos,
    eventLabels
  } = t0;
  let t1;
  if ($[0] !== event.type || $[1] !== eventLabels) {
    t1 = getEventTypeLabel(event.type, eventLabels);
    $[0] = event.type;
    $[1] = eventLabels;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const typeLabel = t1;
  const scorer = event.primaryPlayer;
  const assister = event.secondaryPlayer;
  const score = event.score;
  let t2;
  if ($[3] !== scorer) {
    t2 = getPlayerPhoto(scorer);
    $[3] = scorer;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const scorerPhoto = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <GoalIcon />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== typeLabel) {
    t4 = <div className="flex items-center gap-2 mb-2">{t3}<span className="text-xs font-bold uppercase opacity-90">{typeLabel}</span></div>;
    $[6] = typeLabel;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== scorer?.name || $[9] !== scorerPhoto || $[10] !== showPhotos) {
    t5 = showPhotos && <PlayerImage photoUrl={scorerPhoto} name={scorer?.name || "Unknown"} />;
    $[8] = scorer?.name;
    $[9] = scorerPhoto;
    $[10] = showPhotos;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = scorer?.id;
  const t7 = scorer?.name || "Unknown";
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <PlayerLink playerId={t6} inheritColor={true} className="text-sm font-bold">{t7}</PlayerLink>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== assister || $[16] !== eventLabels) {
    t9 = assister && <p className="text-xs opacity-80">{eventLabels.assist}: <PlayerLink playerId={assister.id} inheritColor={true}>{assister.name}</PlayerLink></p>;
    $[15] = assister;
    $[16] = eventLabels;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <div className="min-w-0 flex-1">{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t5) {
    t11 = <div className="flex items-center gap-2">{t5}{t10}</div>;
    $[21] = t10;
    $[22] = t5;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== score) {
    t12 = score && <div className="mt-2 pt-2 border-t border-current/20"><span className="text-lg font-bold">{score.competitorOne} - {score.competitorTwo}</span></div>;
    $[24] = score;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t4) {
    t13 = <div className="btn-primary p-3 shadow-md min-w-0 w-48 md:w-72">{t4}{t11}{t12}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t4;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};